<script>
    import PlayerDiv from './PlayerDiv.svelte';
	export let pitchers = [];
	export let player_search = "";
	export let selected_team = "";
    export let showPlayerModal;
    export let game_strings = [];
    let sortableCols = {name:0, earned_runs:0, innings_pitched:0, strikeouts:0, wins:0, fp:0, dk_fp:0};
    let sortClasses = ["sort-asc", "", "sort-desc"];
    function sortByX(key, sortableCols, players, toggle=1){
		if(sortableCols[key] == 1){
			sortableCols[key] = -1 * toggle;
		}
		else{
			sortableCols[key] = 1 * toggle;
		}
        //check if players has property stats
        if(key != "name" && players[0].stats){
            players.sort((a, b) => (a.stats[key] > b.stats[key]) ? -1 * sortableCols[key]: 1 * sortableCols[key]);
        }
        else{
            players.sort((a, b) => (a[key] > b[key]) ? -1 * sortableCols[key]: 1 * sortableCols[key]);
        }
        for(var prop in sortableCols){
			if(prop != key){
				sortableCols[prop] = 0;
			}
		}
        return {players:players, sortableCols:sortableCols};
	}
	function filterPlayer(pitcher, name_search, team_search){
		return pitcher.name.toLowerCase().includes(name_search.toLowerCase()) && (team_search == "all" || pitcher.team == team_search);
	}
</script>
<style>
    .sorter{
		padding-right: 30px;
		position:relative;
	}
    .padding-r-30{
        padding-right: 30px;
    }
    .sticky-col {
        position: -webkit-sticky;
        position: sticky;
        left: 0px;
        background-color: #fff;
        z-index: 1;
    }
    .sticky-table-head{
        position: -webkit-sticky;
        position: sticky;
        top: 0px;
        background-color: #fff;
        z-index: 2;
    }
    .sticky-shadow-right{
        /*add webkit box shadow to fix safari bug*/
        -webkit-box-shadow: inset -1px 0px 0px 0px #ccc;
        box-shadow: inset -1px 0px 0px 0px #ccc;
    }
    .sticky-shadow-bottom{
        /*add webkit box shadow to fix safari bug*/
        -webkit-box-shadow: inset 0px -1px 0px 0px #ccc;
        box-shadow: inset 0px -1px 0px 0px #ccc;
    }
    .pointer{
		cursor:pointer;
	}
    .sorter.sort-asc:before{
		opacity: 1 !important;
	}
	.sorter.sort-desc:after{
		opacity: 1 !important;
	}
	.sorter:after,.sorter:before{
		position: absolute;
        bottom: 0em;
        display: block;
        opacity: .3;
		height:100%;
	}
	.sorter:after{
		right: .5em;
		content: "↓";
	}
	.sorter:before{
		right: 1em;
        content: "↑";
	}
</style>
<div class="table-responsive modern-card bg-light m-2 pb-2" style="max-height: 75vh;">
    <table class="table">
        <thead class="sticky-table-head sticky-shadow-bottom pt-2">
            <tr class="ps-2">
                <th on:click={()=>{let sortResult = sortByX("name", sortableCols, pitchers); pitchers = sortResult.players; sortableCols = sortResult.sortableCols;}} class="sticky-col sticky-shadow-right {sortClasses[sortableCols["name"]+1]} padding-r-30 sorter pointer">Name</th>
                <th class="{sortClasses[sortableCols["earned_runs"]+1]} padding-r-30 text-center sorter pointer" on:click={()=>{let sortResult = sortByX("earned_runs", sortableCols, pitchers); pitchers = sortResult.players; sortableCols = sortResult.sortableCols;}}>Earned Runs</th>
                <th class="{sortClasses[sortableCols["innings_pitched"]+1]} padding-r-30 text-center  sorter pointer" on:click={()=>{let sortResult = sortByX("innings_pitched", sortableCols, pitchers); pitchers = sortResult.players; sortableCols = sortResult.sortableCols;}}>Innings Pitched</th>
                <th class="{sortClasses[sortableCols["strikeouts"]+1]}padding-r-30 text-center  sorter pointer" on:click={()=>{let sortResult = sortByX("strikeouts", sortableCols, pitchers); pitchers = sortResult.players; sortableCols = sortResult.sortableCols;}}>Strikeouts</th>
                <th class="{sortClasses[sortableCols["wins"]+1]} padding-r-30 text-center sorter pointer" on:click={()=>{let sortResult = sortByX("wins", sortableCols, pitchers); pitchers = sortResult.players; sortableCols = sortResult.sortableCols;}}>Wins</th>
                <th class="{sortClasses[sortableCols["fp"]+1]} padding-r-30 sorter text-center pointer" on:click={()=>{let sortResult = sortByX("fp", sortableCols, pitchers); pitchers = sortResult.players; sortableCols = sortResult.sortableCols;}}>FD FP</th>
                <th class="{sortClasses[sortableCols["dk_fp"]+1]} padding-r-30 sorter text-center pointer" on:click={()=>{let sortResult = sortByX("dk_fp", sortableCols, pitchers); pitchers = sortResult.players; sortableCols = sortResult.sortableCols;}}>DK FP</th></tr>
        </thead>
        <tbody>
            {#each pitchers as pitcher}
                {#if filterPlayer(pitcher, player_search, selected_team)}
                <tr>
                    <td class="pointer sticky-col sticky-shadow-right pb-0" on:click={()=>{showPlayerModal(pitcher)}}>
                        <PlayerDiv player_image={pitcher.img_thumb} player_positions={pitcher.positions} player_name={pitcher.name} detail_string={game_strings[pitcher.team]} player_inj_tag={pitcher.injury_tag}/>
                    </td>
                    <td class="align-bottom padding-r-30 text-center">{pitcher.stats.earned_runs}</td>
                    <td class="align-bottom padding-r-30 text-center">{pitcher.stats.innings_pitched}</td>
                    <td class="align-bottom padding-r-30 text-center">{pitcher.stats.strikeouts}</td>
                    <td class="align-bottom padding-r-30 text-center">{pitcher.stats.wins}</td>
                    <td class="align-bottom padding-r-30 text-center">{pitcher.stats.fp}</td>
                    <td class="align-bottom padding-r-30 text-center">{pitcher.stats.dk_fp}</td>
                </tr>
                {/if}
            {/each}
        </tbody>
    </table>
</div>

